import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UserDTO } from '../../../interfaces/user.interface';
import { MatTableDataSource } from '@angular/material/table';
import { expandableRowAnimation } from '../../../roles/role-list-table/expandable-row.animation';
import { MatPaginator } from '@angular/material/paginator';
import { UsersService } from '../../../services/users.service';

@Component({
  selector: 'app-users-list-table',
  templateUrl: './users-list-table.component.html',
  styleUrls: ['./users-list-table.component.scss'],
  animations: [expandableRowAnimation],
})
export class UsersListTableComponent implements OnChanges {

  public dataSource = new MatTableDataSource<UserDTO>([]);
  public selectedRut: string | null = null;
  @Output() notify: EventEmitter<string> = new EventEmitter();
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  @Input() public users: Array<UserDTO>;
  public displayedColumns = [
    'expandArrow',
    'rut',
    'firstName',
    //'lastName',
    'email',
    'roles',
    'enabled'
    // 'star'
  ]

  constructor( private userService: UsersService, ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataSource.data = this.users;
    this.dataSource.paginator = this.paginator;
  }

  toggleExpandable(userId: string) {
    this.selectedRut = this.selectedRut !== null && this.selectedRut === userId ? null : userId;
  }

  convertStringToList(input: string, delimiter: string = ';'): string[] {
    if (!input) {
      return [];
    }
    return input.split(delimiter);
  }

  transformStringRut(rut: string) :number {
    const cleanedRutWithoutDots = rut.replace(/\./g, '');
    const userRut = parseInt(
      cleanedRutWithoutDots.substring(0, cleanedRutWithoutDots.length - 1)
    );
    return userRut
  }

  reciveNotify(mensaje: any) {
    this.notify.emit();
  }

  habilitarUser(rut: string) {
    var userId = this.transformStringRut(rut);
    this.userService.enabledToUser(userId).subscribe({
      next:(response) => {
        this.reciveNotify("");
      },
      error:(err) => {
        console.log(err);
      }
    });
  }

  dehabilitarUser(rut: string) {
    var userId = this.transformStringRut(rut);
    this.userService.disabledToUser(userId).subscribe({
      next:(response) => {
        this.reciveNotify("");
      },
      error:(err) => {
        console.log(err);
      }
    });
  }

}
